module.exports = __webpack_public_path__ + "static/media/footerFacebook.25d72c7d.svg";